import { autoGrow } from '../../common/autoGrow';

/**
 * The line caps this widget's prose fields grow to. The sizing itself is shared
 * (`widgets/common/autoGrow.js`) because the composer uses it too; these three numbers are Mission
 * Control's own judgement about how much screen each field may take.
 */

/** A title is a phrase. Three lines is already generous; past that it is a description. */
export const TITLE_ROWS = 3;

/** A description is prose, and five lines is about what fits beside a graph without crowding it. */
export const DESCRIPTION_ROWS = 5;

/**
 * An answer to a question is prose too, and it is the thing the options did not cover — so it is
 * the field most likely to run long. Six is a paragraph; past it the FIELD scrolls, which is what
 * keeps a long answer from pushing the questions under it off the screen.
 */
export const ANSWER_ROWS = 6;

export { autoGrow };
export default autoGrow;
